// extracted by mini-css-extract-plugin
export var button = "survey-success-module--button--rThr0";
export var happyEnd = "survey-success-module--happy-end--aRa4b";
export var header = "survey-success-module--header--cMFBu";
export var imgWrapper = "survey-success-module--img-wrapper--nT-oo";
export var logo = "survey-success-module--logo---b7tL";
export var portrait = "survey-success-module--portrait--7kz5e";
export var success = "survey-success-module--success--J7ZH7";
export var surveyEnd = "survey-success-module--survey-end--7usFX";
export var surveySuccess = "survey-success-module--survey-success--KN39x";
export var surveySuccessLeftWrapper = "survey-success-module--survey-success-left-wrapper--52Hy0";
export var surveySuccessRightContent = "survey-success-module--survey-success-right-content--EqVZ9";
export var surveySuccessRightWrapper = "survey-success-module--survey-success-right-wrapper--NDz-t";